// "use client";
//
// import { AnimalCard } from "@/features/Animals/Animal-Card.tsx";
// import { FormValues } from "@/models/Sila.Animals.schema.ts";
// import { Card, CardBody } from "@heroui/card";
// import { Animal } from "@/features/Animals/AnimalColumns.ts";
// // actual structure
// // (you can remove this
// // when using real
// // data)
//
// // Sample data with the actual structure (you can remove this when using real
// data)  export function PedigreeTree({ animal }: { animal: any })
// { //
// Get the
// selected animal data  if (!animal) { return ( <div
// className="w-full p-8
// text-center text-gray-500"> No animal data available </div> ); }  //
// Helper
// function to create animal objects from the pedigree data const
// createAnimalFromPedigree = ( name?: string, dgr?: string, breed?: string, ) => {
// if (!name) return null; return { id: dgr || name, name, breed: breed ||
// "Unknown", birthDate: "", awards: [], image: "/public/Placeholder-Bull.png",
// color: "", registration: dgr || "", sire: null, dam: null, }; };  // Create
// animal objects for display const sire = createAnimalFromPedigree(
// animal.sireName, animal.sireDGR, animal.sireBreed, );
// const
// dam =
// createAnimalFromPedigree( animal.damName, animal.damDGR,
// animal.damBreed, );
// const paternalGrandSire = createAnimalFromPedigree(
// animal.paternalGrandSireName,
// animal.paternalGrandSireDGR, animal.paternalGrandSireBreed, );
// const
// paternalGrandDam = createAnimalFromPedigree( animal.paternalGrandDamName,
// animal.paternalGrandDamDGR, animal.paternalGrandDamBreed, );
// const
// maternalGrandSire = createAnimalFromPedigree(
// animal.maternalGrandSireName,
// animal.maternalGrandSireDGR, animal.maternalGrandSireBreed, );
// const
// maternalGrandDam = createAnimalFromPedigree( animal.maternalGrandDamName,
// animal.maternalGrandDamDGR, animal.maternalGrandDamBreed, );
// const
// getImageUrl =
// (animal: Animal | FormValues): string => { // If FormValues type with
// imageUrls
// as array if ( Array.isArray((animal as any).imageUrls) &&
// (animal as
// any).imageUrls.length > 0 ) { return (animal as any).imageUrls[0]; } // If
// FormValues type with imageUrls as string if ( typeof (animal as
// any).imageUrls
// === "string" && (animal as any).imageUrls.trim() !== "" ) { return
// (animal as
// any).imageUrls; } // If Animal type with image property if ( typeof
// (animal as
// any).image === "string" && (animal as any).image.trim() !== "" ) { return
// (animal
// as any).image; } // fallback return "/placeholder.svg?height=64&width=64"; };  //
// Usage in your component: const image = getImageUrl(animal);  // Convert
// current
// animal to the format expected by AnimalCard const displayAnimal = { // id:
// animal._id, name: animal.name ?? "N/A", breed: "Cattle", // Since
// there's no
// breed field for the main animal birthDate: animal.birthDate, //
// Calculate
// from
// age if needed image: image, // image: animal.imageUrls //   ?
// animal.imageUrls[0]
// //   : "/placeholder.svg?height=64&width=64", color: animal.coatColor ??
// "N/A",
// registration: animal.dgr ?? "N/A", sire: null, dam: null, // Additional
// info for
// display sex: animal.sex, age: animal.age, weight:
// animal.weight, };
// return (
// <div className="w-full z-50"> {/* Pedigree tree */}  <Card className="shadow-2xl
// border border-yellow-100 rounded-lg"> <CardBody className="p-2"> <div
// className="p-4 pedigree-tree w-full overflow-x-auto bg-slate-100"> <div
// className="min-w-[900px] pb-10"> {/* Main structure with connecting lines */}
// <div className="relative"> {/* Generation 1 (Selected Animal) */} <div
// className="flex justify-center mb-16"> <div className="w-64"> <AnimalCard
// animal={displayAnimal} highlight /> </div> </div>  {/* Connecting lines
// from
// animal to parents */} {(sire || dam) && ( <> <div className="absolute
// top-[120px]
// left-1/2 w-[2px] h-8 bg-gray-300"></div> <div className="absolute top-[128px]
// left-1/2 w-[400px] h-[2px] bg-gray-300 -translate-x-1/2"></div> <div
// className="absolute top-[128px] left-[calc(25%-32px)] w-[2px] h-8
// bg-gray-300"></div> <div className="absolute top-[128px] left-[calc(75%+32px)]
// w-[2px] h-8 bg-gray-300"></div> </> )}  {/* Generation 2 (Parents) */} <div
// className="flex justify-between mb-16"> <div className="w-64"> {sire ? (
// <AnimalCard animal={sire} label="Sire" /> ) : ( <div className="h-[150px]
// border
// border-dashed border-gray-300 rounded-lg flex items-center justify-center
// text-gray-400"> No Sire Data </div> )} </div> <div className="w-64"> {dam ? (
// <AnimalCard animal={dam} label="Dam" /> ) : ( <div className="h-[150px]
// border
// border-dashed border-gray-300 rounded-lg flex items-center justify-center
// text-gray-400"> No Dam Data </div> )} </div> </div>  {/* Connecting lines from
// parents to grandparents */} {/* Sire to grandparents */} {sire &&
// (paternalGrandSire || paternalGrandDam) && ( <> <div className="absolute
// top-[296px] left-[calc(25%-32px)] w-[2px] h-8 bg-gray-300"></div> <div
// className="absolute top-[304px] left-[calc(25%-32px)] w-[200px] h-[2px]
// bg-gray-300 -translate-x-1/2"></div> <div className="absolute top-[304px]
// left-[calc(12.5%-16px)] w-[2px] h-8 bg-gray-300"></div> <div className="absolute
// top-[304px] left-[calc(37.5%-48px)] w-[2px] h-8 bg-gray-300"></div> </> )}  {/*
// Dam to grandparents */} {dam && (maternalGrandSire || maternalGrandDam) && ( <>
// <div className="absolute top-[296px] left-[calc(75%+32px)] w-[2px] h-8
// bg-gray-300"></div> <div className="absolute top-[304px] left-[calc(75%+32px)]
// w-[200px] h-[2px] bg-gray-300 -translate-x-1/2"></div> <div className="absolute
// top-[304px] left-[calc(62.5%+16px)] w-[2px] h-8 bg-gray-300"></div> <div
// className="absolute top-[304px] left-[calc(87.5%+48px)] w-[2px] h-8
// bg-gray-300"></div> </> )}  {/* Generation 3 (Grandparents) */} <div
// className="grid grid-cols-4 gap-4"> {/* Paternal Grandparents */} <div>
// {paternalGrandSire ? ( <AnimalCard animal={paternalGrandSire}
// label="Paternal
// Grand
// Sire" compact /> ) : ( <div className="h-[120px] border border-dashed
// border-gray-300 rounded-lg flex items-center justify-center text-gray-400
// text-xs p-2 text-center"> No Paternal Grand Sire Data </div> )} </div> <div>
// {paternalGrandDam ? ( <AnimalCard animal={paternalGrandDam}
// label="Paternal
// Grand
// Dam" compact /> ) : ( <div className="h-[120px] border border-dashed
// border-gray-300 rounded-lg flex items-center justify-center text-gray-400
// text-xs p-2 text-center"> No Paternal Grand Dam Data </div> )} </div>  {/*
// Maternal Grandparents */} <div> {maternalGrandSire ? ( <AnimalCard
// animal={maternalGrandSire} label="Maternal Grand Sire" compact /> ) : (
// <div
// className="h-[120px] border border-dashed border-gray-300 rounded-lg flex
// items-center justify-center text-gray-400 text-xs p-2 text-center"> No
// Maternal Grand Sire Data </div> )} </div> <div> {maternalGrandDam ? (
// <AnimalCard animal={maternalGrandDam} label="Maternal Grand Dam" compact
// /> ) :
// ( <div className="h-[120px] border border-dashed border-gray-300 rounded-lg flex
// items-center justify-center text-gray-400 text-xs p-2 text-center"> No Maternal
// Grand Dam Data </div> )} </div> </div> </div> </div> </div> </CardBody> </Card>
// </div> ); }

"use client";

import { AnimalCard } from "./Animal-Card";
import { FormValues } from "@/models/Sila.Animals.schema.ts";

// interface TAnimals extends FormValues {
//   _id: string;
// }

export function PedigreeTree({ animal }: { animal: FormValues }) {
  if (!animal) {
    return (
      <div className="w-full p-8 text-center text-gray-500">
        No animal data available
      </div>
    );
  }

  // Helper function to create animal objects from the pedigree data
  const createAnimalFromPedigree = (
    name?: string,
    dgr?: string,
    breed?: string,
    imageUrl?: string,
  ) => {
    if (!name) return null;
    return {
      id: dgr || name,
      name,
      breed: breed || "Unknown",
      birthDate: "",
      awards: [],
      image: imageUrl ?? "/Placeholder-Bull.png",
      color: "",
      registration: dgr || "",
      sire: null,
      dam: null,
    };
  };

  // Create Parent objects for display
  const sire = createAnimalFromPedigree(
    animal.sireName,
    animal.sireDGR,
    animal.sireBreed,
    animal.sireImageUrl,
  );
  const dam = createAnimalFromPedigree(
    animal.damName,
    animal.damDGR,
    animal.damBreed,
    animal.damImageUrl,
  );

  // Create Grandparent objects for display
  const paternalGrandSire = createAnimalFromPedigree(
    animal.paternalGrandSireName,
    animal.paternalGrandSireDGR,
    animal.paternalGrandSireBreed,
    animal.paternalGrandSireImageUrl,
  );
  const paternalGrandDam = createAnimalFromPedigree(
    animal.paternalGrandDamName,
    animal.paternalGrandDamDGR,
    animal.paternalGrandDamBreed,
    animal.paternalGrandDamImageUrl,
  );
  const maternalGrandSire = createAnimalFromPedigree(
    animal.maternalGrandSireName,
    animal.maternalGrandSireDGR,
    animal.maternalGrandSireBreed,
    animal.maternalGrandSireImageUrl,
  );
  const maternalGrandDam = createAnimalFromPedigree(
    animal.maternalGrandDamName,
    animal.maternalGrandDamDGR,
    animal.maternalGrandDamBreed,
    animal.maternalGrandDamImageUrl,
  );

  // Create all 8 Great-Grandparent objects for display using the correct schema
  // names
  const paternalGrandSireGrandSire = createAnimalFromPedigree(
    animal.paternalGrandSireGrandSireName,
    animal.paternalGrandSireGrandSireDGR,
    animal.paternalGrandSireGrandSireBreed,
    animal.paternalGrandSireGrandSireImageUrl,
  );
  const paternalGrandSireGrandDam = createAnimalFromPedigree(
    animal.paternalGrandSireGrandDamName,
    animal.paternalGrandSireGrandDamDGR,
    animal.paternalGrandSireGrandDamBreed,
    animal.paternalGrandSireGrandDamImageUrl,
  );
  const paternalGrandDamGrandSire = createAnimalFromPedigree(
    animal.paternalGrandDamGrandSireName,
    animal.paternalGrandDamGrandSireDGR,
    animal.paternalGrandDamGrandSireBreed,
    animal.paternalGrandDamGrandSireImageUrl,
  );
  const paternalGrandDamGrandDam = createAnimalFromPedigree(
    animal.paternalGrandDamGrandDamName,
    animal.paternalGrandDamGrandDamDGR,
    animal.paternalGrandDamGrandDamBreed,
    animal.paternalGrandDamGrandDamImageUrl,
  );
  const maternalGrandSireGrandSire = createAnimalFromPedigree(
    animal.maternalGrandSireGrandSireName,
    animal.maternalGrandSireGrandSireDGR,
    animal.maternalGrandSireGrandSireBreed,
    animal.maternalGrandSireGrandSireImageUrl,
  );
  const maternalGrandSireGrandDam = createAnimalFromPedigree(
    animal.maternalGrandSireGrandDamName,
    animal.maternalGrandSireGrandDamDGR,
    animal.maternalGrandSireGrandDamBreed,
    animal.maternalGrandSireGrandDamImageUrl,
  );
  const maternalGrandDamGrandSire = createAnimalFromPedigree(
    animal.maternalGrandDamGrandSireName,
    animal.maternalGrandDamGrandSireDGR,
    animal.maternalGrandDamGrandSireBreed,
    animal.maternalGrandDamGrandSireImageUrl,
  );
  const maternalGrandDamGrandDam = createAnimalFromPedigree(
    animal.maternalGrandDamGrandDamName,
    animal.maternalGrandDamGrandDamDGR,
    animal.maternalGrandDamGrandDamBreed,
    animal.maternalGrandDamGrandDamImageUrl,
  );

  // FIX 2: Normalize the main animal's data to match what AnimalCard expects
  const displayAnimal = {
    id: animal.dgr,
    name: animal?.name ?? "N/A",
    // Get the first image from the array or use a fallback
    image:
      animal.imageUrls && animal.imageUrls.length > 0
        ? animal.imageUrls[0]
        : "/placeholder.svg?height=64&width=64",
    dgr: animal.dgr,
    birthDate: animal.birthDate,
    age: animal.age,
    sex: animal.sex,
    coatColor: animal.coatColor,
    weight: animal.weight,
    racialComposition: animal.racialComposition,
  };
  return (
    <div className="w-full">
      {/* Pedigree tree */}
      <div className="pedigree-tree w-full overflow-x-auto">
        <div className="min-w-[1200px] pb-10">
          {/* Main structure with connecting lines */}
          <div className="relative">
            {/* Generation 1 (Selected Animal) */}
            <div className="flex justify-center mb-16">
              <div className="w-64">
                <AnimalCard animal={displayAnimal} highlight />
              </div>
            </div>

            {/* Connecting lines from animal to parents */}
            {(sire || dam) && (
              <>
                <div className="absolute top-[120px] left-1/2 w-px h-8 bg-gray-300"></div>
                <div className="absolute top-[128px] left-1/2 w-[400px] h-px bg-gray-300 -translate-x-1/2"></div>
                <div className="absolute top-[128px] left-[calc(25%-32px)] w-px h-8 bg-gray-300"></div>
                <div className="absolute top-[128px] left-[calc(75%+32px)] w-px h-8 bg-gray-300"></div>
              </>
            )}

            {/* Generation 2 (Parents) */}
            <div className="flex justify-between mb-16">
              <div className="w-64">
                {sire ? (
                  <AnimalCard animal={sire} label="Sire" />
                ) : (
                  <div className="h-[150px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400">
                    No Sire Data
                  </div>
                )}
              </div>
              <div className="w-64">
                {dam ? (
                  <AnimalCard animal={dam} label="Dam" />
                ) : (
                  <div className="h-[150px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400">
                    No Dam Data
                  </div>
                )}
              </div>
            </div>

            {/* Connecting lines from parents to grandparents */}
            {/* Sire to grandparents */}
            {sire && (paternalGrandSire || paternalGrandDam) && (
              <>
                <div className="absolute top-[296px] left-[calc(25%-32px)] w-px h-8 bg-gray-300"></div>
                <div className="absolute top-[304px] left-[calc(25%-32px)] w-[200px] h-px bg-gray-300 -translate-x-1/2"></div>
                <div className="absolute top-[304px] left-[calc(12.5%-16px)] w-px h-8 bg-gray-300"></div>
                <div className="absolute top-[304px] left-[calc(37.5%-48px)] w-px h-8 bg-gray-300"></div>
              </>
            )}

            {/* Dam to grandparents */}
            {dam && (maternalGrandSire || maternalGrandDam) && (
              <>
                <div className="absolute top-[296px] left-[calc(75%+32px)] w-px h-8 bg-gray-300"></div>
                <div className="absolute top-[304px] left-[calc(75%+32px)] w-[200px] h-px bg-gray-300 -translate-x-1/2"></div>
                <div className="absolute top-[304px] left-[calc(62.5%+16px)] w-px h-8 bg-gray-300"></div>
                <div className="absolute top-[304px] left-[calc(87.5%+48px)] w-px h-8 bg-gray-300"></div>
              </>
            )}

            {/* Generation 3 (Grandparents) */}
            <div className="grid grid-cols-4 gap-4">
              {/* Paternal Grandparents */}
              <div>
                {paternalGrandSire ? (
                  <AnimalCard
                    animal={paternalGrandSire}
                    label="Paternal Grand Sire"
                    compact
                  />
                ) : (
                  <div className="h-[120px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-2 text-center">
                    No Paternal Grand Sire Data
                  </div>
                )}
              </div>
              <div>
                {paternalGrandDam ? (
                  <AnimalCard
                    animal={paternalGrandDam}
                    label="Paternal Grand Dam"
                    compact
                  />
                ) : (
                  <div className="h-[120px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-2 text-center">
                    No Paternal Grand Dam Data
                  </div>
                )}
              </div>

              {/* Maternal Grandparents */}
              <div>
                {maternalGrandSire ? (
                  <AnimalCard
                    animal={maternalGrandSire}
                    label="Maternal Grand Sire"
                    compact
                  />
                ) : (
                  <div className="h-[120px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-2 text-center">
                    No Maternal Grand Sire Data
                  </div>
                )}
              </div>
              <div>
                {maternalGrandDam ? (
                  <AnimalCard
                    animal={maternalGrandDam}
                    label="Maternal Grand Dam"
                    compact
                  />
                ) : (
                  <div className="h-[120px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-2 text-center">
                    No Maternal Grand Dam Data
                  </div>
                )}
              </div>
            </div>

            {/* Generation 4 (Great-Grandparents) */}
            <div className="grid grid-cols-8 gap-2 mt-16">
              {/* Paternal Great-Grandparents (from Paternal Grand Sire) */}
              <div>
                {paternalGrandSireGrandSire ? (
                  <AnimalCard
                    animal={paternalGrandSireGrandSire}
                    label="Pat. Gt. Grand Sire"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>
              <div>
                {paternalGrandSireGrandDam ? (
                  <AnimalCard
                    animal={paternalGrandSireGrandDam}
                    label="Pat. Gt. Grand Dam"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>

              {/* Paternal Great-Grandparents (from Paternal Grand Dam) */}
              <div>
                {paternalGrandDamGrandSire ? (
                  <AnimalCard
                    animal={paternalGrandDamGrandSire}
                    label="Pat. Gt. Grand Sire"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>
              <div>
                {paternalGrandDamGrandDam ? (
                  <AnimalCard
                    animal={paternalGrandDamGrandDam}
                    label="Pat. Gt. Grand Dam"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>

              {/* Maternal Great-Grandparents (from Maternal Grand Sire) */}
              <div>
                {maternalGrandSireGrandSire ? (
                  <AnimalCard
                    animal={maternalGrandSireGrandSire}
                    label="Mat. Gt. Grand Sire"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>
              <div>
                {maternalGrandSireGrandDam ? (
                  <AnimalCard
                    animal={maternalGrandSireGrandDam}
                    label="Mat. Gt. Grand Dam"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>

              {/* Maternal Great-Grandparents (from Maternal Grand Dam) */}
              <div>
                {maternalGrandDamGrandSire ? (
                  <AnimalCard
                    animal={maternalGrandDamGrandSire}
                    label="Mat. Gt. Grand Sire"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>
              <div>
                {maternalGrandDamGrandDam ? (
                  <AnimalCard
                    animal={maternalGrandDamGrandDam}
                    label="Mat. Gt. Grand Dam"
                    compact
                  />
                ) : (
                  <div className="h-[100px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-gray-400 text-xs p-1 text-center">
                    No Data
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Legend and instructions */}
      <div className="mt-8 bg-gray-50 p-4 rounded-lg">
        <h3 className="font-medium mb-2">How to Use</h3>
        <ul className="text-sm space-y-1 text-gray-700">
          <li>• Select an animal from the dropdown to view its pedigree</li>
          <li>• The selected animal appears at the top of the tree</li>
          <li>• Parents (Sire and Dam) appear in the second row</li>
          <li>• Grandparents appear in the third row</li>
          <li>• Great-grandparents appear in the fourth row</li>
          <li>• Click on any animal card to see more details</li>
          <li>• DGR numbers are displayed as registration information</li>
        </ul>
      </div>
    </div>
  );
}
